import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-occupational-health-and-safety-act-post',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './occupational-health-and-safety-act-post.component.html',
  styleUrls: ['./occupational-health-and-safety-act-post.component.scss']
})
export class OccupationalHealthAndSafetyActPostComponent {
  EnPage:boolean = this.translate.currentLang == 'en' ;
  FrPage:boolean = this.translate.currentLang != 'en' ;
  constructor(private translate: TranslateService, private router: Router, private activatedRoute: ActivatedRoute) { }

}
